export enum PatientType {
  HOLDER = 'titular',
  DEPENDENT = 'dependente',
}

export interface ScheduleAgeRange {
  minAge?: number | null;
  maxAge?: number | null;
}

export interface PatientOption {
  id: string;
  name: string;
  documentNumber: string;
  age?: number;
  type: PatientType;
  isWithinAgeRange: boolean;
}
